/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as ApplyPromotionRouteImport } from './routes/apply-promotion'
import { Route as AppRouteImport } from './routes/_app'
import { Route as ComplianceTestIndexRouteImport } from './routes/compliance-test/index'
import { Route as AuthIndexRouteImport } from './routes/auth/index'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as ComplianceTestQuizRouteImport } from './routes/compliance-test/quiz'
import { Route as AuthVerifyAccountRouteImport } from './routes/auth/verify-account'
import { Route as AuthSignupRouteImport } from './routes/auth/signup'
import { Route as AuthSigninRouteImport } from './routes/auth/signin'
import { Route as AuthForgotPasswordRouteImport } from './routes/auth/forgot-password'
import { Route as AppVexonRouteImport } from './routes/_app/vexon'
import { Route as AppStealthAiWriterRouteImport } from './routes/_app/stealth-ai-writer'
import { Route as AppSeoScannerRouteImport } from './routes/_app/seo-scanner'
import { Route as AppSecureLlmRouteImport } from './routes/_app/secure-llm'
import { Route as AppPricingRouteImport } from './routes/_app/pricing'
import { Route as AppHistoryRouteImport } from './routes/_app/history'
import { Route as AppDocumentRedactorRouteImport } from './routes/_app/document-redactor'
import { Route as AppContentHumanizerRouteImport } from './routes/_app/content-humanizer'
import { Route as AppContentEnhancerRouteImport } from './routes/_app/content-enhancer'
import { Route as AppContactUsRouteImport } from './routes/_app/contact-us'
import { Route as AppApiAgentDocNewRouteImport } from './routes/_app/api-agent-doc-new'
import { Route as AppApiAgentDocRouteImport } from './routes/_app/api-agent-doc'
import { Route as AppAllProductsRouteImport } from './routes/_app/all-products'
import { Route as AppAccountRouteImport } from './routes/_app/account'
import { Route as AppProvenanceRouteImport } from './routes/_app/_provenance'
import { Route as AppVexonIndexRouteImport } from './routes/_app/vexon/index'
import { Route as AppStealthAiWriterIndexRouteImport } from './routes/_app/stealth-ai-writer/index'
import { Route as AppDocumentRedactorIndexRouteImport } from './routes/_app/document-redactor/index'
import { Route as AppVexonResultRouteImport } from './routes/_app/vexon/result'
import { Route as AppStealthAiWriterResultRouteImport } from './routes/_app/stealth-ai-writer/result'
import { Route as AppStealthAiWriterGenerateArticleRouteImport } from './routes/_app/stealth-ai-writer/generate-article'
import { Route as AppPaymentConfirmationOutcomeRouteImport } from './routes/_app/payment-confirmation/$outcome'
import { Route as AppDocumentRedactorResultRouteImport } from './routes/_app/document-redactor/result'
import { Route as AppDocumentRedactorOptionsRouteImport } from './routes/_app/document-redactor/options'
import { Route as AppProvenanceWritingAnalysisRouteImport } from './routes/_app/_provenance/writing-analysis'
import { Route as AppProvenanceHumanizedTextDetectorRouteImport } from './routes/_app/_provenance/humanized-text-detector'
import { Route as AppProvenanceCopyrightDetectorRouteImport } from './routes/_app/_provenance/copyright-detector'
import { Route as AppProvenanceAiDetectorRouteImport } from './routes/_app/_provenance/ai-detector'

const AuthRoute = AuthRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const ApplyPromotionRoute = ApplyPromotionRouteImport.update({
  id: '/apply-promotion',
  path: '/apply-promotion',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const ComplianceTestIndexRoute = ComplianceTestIndexRouteImport.update({
  id: '/compliance-test/',
  path: '/compliance-test/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthIndexRoute = AuthIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthRoute,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const ComplianceTestQuizRoute = ComplianceTestQuizRouteImport.update({
  id: '/compliance-test/quiz',
  path: '/compliance-test/quiz',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthVerifyAccountRoute = AuthVerifyAccountRouteImport.update({
  id: '/verify-account',
  path: '/verify-account',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSignupRoute = AuthSignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSigninRoute = AuthSigninRouteImport.update({
  id: '/signin',
  path: '/signin',
  getParentRoute: () => AuthRoute,
} as any)
const AuthForgotPasswordRoute = AuthForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => AuthRoute,
} as any)
const AppVexonRoute = AppVexonRouteImport.update({
  id: '/vexon',
  path: '/vexon',
  getParentRoute: () => AppRoute,
} as any)
const AppStealthAiWriterRoute = AppStealthAiWriterRouteImport.update({
  id: '/stealth-ai-writer',
  path: '/stealth-ai-writer',
  getParentRoute: () => AppRoute,
} as any)
const AppSeoScannerRoute = AppSeoScannerRouteImport.update({
  id: '/seo-scanner',
  path: '/seo-scanner',
  getParentRoute: () => AppRoute,
} as any)
const AppSecureLlmRoute = AppSecureLlmRouteImport.update({
  id: '/secure-llm',
  path: '/secure-llm',
  getParentRoute: () => AppRoute,
} as any)
const AppPricingRoute = AppPricingRouteImport.update({
  id: '/pricing',
  path: '/pricing',
  getParentRoute: () => AppRoute,
} as any)
const AppHistoryRoute = AppHistoryRouteImport.update({
  id: '/history',
  path: '/history',
  getParentRoute: () => AppRoute,
} as any)
const AppDocumentRedactorRoute = AppDocumentRedactorRouteImport.update({
  id: '/document-redactor',
  path: '/document-redactor',
  getParentRoute: () => AppRoute,
} as any)
const AppContentHumanizerRoute = AppContentHumanizerRouteImport.update({
  id: '/content-humanizer',
  path: '/content-humanizer',
  getParentRoute: () => AppRoute,
} as any)
const AppContentEnhancerRoute = AppContentEnhancerRouteImport.update({
  id: '/content-enhancer',
  path: '/content-enhancer',
  getParentRoute: () => AppRoute,
} as any)
const AppContactUsRoute = AppContactUsRouteImport.update({
  id: '/contact-us',
  path: '/contact-us',
  getParentRoute: () => AppRoute,
} as any)
const AppApiAgentDocNewRoute = AppApiAgentDocNewRouteImport.update({
  id: '/api-agent-doc-new',
  path: '/api-agent-doc-new',
  getParentRoute: () => AppRoute,
} as any)
const AppApiAgentDocRoute = AppApiAgentDocRouteImport.update({
  id: '/api-agent-doc',
  path: '/api-agent-doc',
  getParentRoute: () => AppRoute,
} as any)
const AppAllProductsRoute = AppAllProductsRouteImport.update({
  id: '/all-products',
  path: '/all-products',
  getParentRoute: () => AppRoute,
} as any)
const AppAccountRoute = AppAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => AppRoute,
} as any)
const AppProvenanceRoute = AppProvenanceRouteImport.update({
  id: '/_provenance',
  getParentRoute: () => AppRoute,
} as any)
const AppVexonIndexRoute = AppVexonIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppVexonRoute,
} as any)
const AppStealthAiWriterIndexRoute = AppStealthAiWriterIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppStealthAiWriterRoute,
} as any)
const AppDocumentRedactorIndexRoute =
  AppDocumentRedactorIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppDocumentRedactorRoute,
  } as any)
const AppVexonResultRoute = AppVexonResultRouteImport.update({
  id: '/result',
  path: '/result',
  getParentRoute: () => AppVexonRoute,
} as any)
const AppStealthAiWriterResultRoute =
  AppStealthAiWriterResultRouteImport.update({
    id: '/result',
    path: '/result',
    getParentRoute: () => AppStealthAiWriterRoute,
  } as any)
const AppStealthAiWriterGenerateArticleRoute =
  AppStealthAiWriterGenerateArticleRouteImport.update({
    id: '/generate-article',
    path: '/generate-article',
    getParentRoute: () => AppStealthAiWriterRoute,
  } as any)
const AppPaymentConfirmationOutcomeRoute =
  AppPaymentConfirmationOutcomeRouteImport.update({
    id: '/payment-confirmation/$outcome',
    path: '/payment-confirmation/$outcome',
    getParentRoute: () => AppRoute,
  } as any)
const AppDocumentRedactorResultRoute =
  AppDocumentRedactorResultRouteImport.update({
    id: '/result',
    path: '/result',
    getParentRoute: () => AppDocumentRedactorRoute,
  } as any)
const AppDocumentRedactorOptionsRoute =
  AppDocumentRedactorOptionsRouteImport.update({
    id: '/options',
    path: '/options',
    getParentRoute: () => AppDocumentRedactorRoute,
  } as any)
const AppProvenanceWritingAnalysisRoute =
  AppProvenanceWritingAnalysisRouteImport.update({
    id: '/writing-analysis',
    path: '/writing-analysis',
    getParentRoute: () => AppProvenanceRoute,
  } as any)
const AppProvenanceHumanizedTextDetectorRoute =
  AppProvenanceHumanizedTextDetectorRouteImport.update({
    id: '/humanized-text-detector',
    path: '/humanized-text-detector',
    getParentRoute: () => AppProvenanceRoute,
  } as any)
const AppProvenanceCopyrightDetectorRoute =
  AppProvenanceCopyrightDetectorRouteImport.update({
    id: '/copyright-detector',
    path: '/copyright-detector',
    getParentRoute: () => AppProvenanceRoute,
  } as any)
const AppProvenanceAiDetectorRoute = AppProvenanceAiDetectorRouteImport.update({
  id: '/ai-detector',
  path: '/ai-detector',
  getParentRoute: () => AppProvenanceRoute,
} as any)

export interface FileRoutesByFullPath {
  '/apply-promotion': typeof ApplyPromotionRoute
  '/auth': typeof AuthRouteWithChildren
  '/account': typeof AppAccountRoute
  '/all-products': typeof AppAllProductsRoute
  '/api-agent-doc': typeof AppApiAgentDocRoute
  '/api-agent-doc-new': typeof AppApiAgentDocNewRoute
  '/contact-us': typeof AppContactUsRoute
  '/content-enhancer': typeof AppContentEnhancerRoute
  '/content-humanizer': typeof AppContentHumanizerRoute
  '/document-redactor': typeof AppDocumentRedactorRouteWithChildren
  '/history': typeof AppHistoryRoute
  '/pricing': typeof AppPricingRoute
  '/secure-llm': typeof AppSecureLlmRoute
  '/seo-scanner': typeof AppSeoScannerRoute
  '/stealth-ai-writer': typeof AppStealthAiWriterRouteWithChildren
  '/vexon': typeof AppVexonRouteWithChildren
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/signin': typeof AuthSigninRoute
  '/auth/signup': typeof AuthSignupRoute
  '/auth/verify-account': typeof AuthVerifyAccountRoute
  '/compliance-test/quiz': typeof ComplianceTestQuizRoute
  '/': typeof AppIndexRoute
  '/auth/': typeof AuthIndexRoute
  '/compliance-test': typeof ComplianceTestIndexRoute
  '/ai-detector': typeof AppProvenanceAiDetectorRoute
  '/copyright-detector': typeof AppProvenanceCopyrightDetectorRoute
  '/humanized-text-detector': typeof AppProvenanceHumanizedTextDetectorRoute
  '/writing-analysis': typeof AppProvenanceWritingAnalysisRoute
  '/document-redactor/options': typeof AppDocumentRedactorOptionsRoute
  '/document-redactor/result': typeof AppDocumentRedactorResultRoute
  '/payment-confirmation/$outcome': typeof AppPaymentConfirmationOutcomeRoute
  '/stealth-ai-writer/generate-article': typeof AppStealthAiWriterGenerateArticleRoute
  '/stealth-ai-writer/result': typeof AppStealthAiWriterResultRoute
  '/vexon/result': typeof AppVexonResultRoute
  '/document-redactor/': typeof AppDocumentRedactorIndexRoute
  '/stealth-ai-writer/': typeof AppStealthAiWriterIndexRoute
  '/vexon/': typeof AppVexonIndexRoute
}
export interface FileRoutesByTo {
  '/apply-promotion': typeof ApplyPromotionRoute
  '/account': typeof AppAccountRoute
  '/all-products': typeof AppAllProductsRoute
  '/api-agent-doc': typeof AppApiAgentDocRoute
  '/api-agent-doc-new': typeof AppApiAgentDocNewRoute
  '/contact-us': typeof AppContactUsRoute
  '/content-enhancer': typeof AppContentEnhancerRoute
  '/content-humanizer': typeof AppContentHumanizerRoute
  '/history': typeof AppHistoryRoute
  '/pricing': typeof AppPricingRoute
  '/secure-llm': typeof AppSecureLlmRoute
  '/seo-scanner': typeof AppSeoScannerRoute
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/signin': typeof AuthSigninRoute
  '/auth/signup': typeof AuthSignupRoute
  '/auth/verify-account': typeof AuthVerifyAccountRoute
  '/compliance-test/quiz': typeof ComplianceTestQuizRoute
  '/': typeof AppIndexRoute
  '/auth': typeof AuthIndexRoute
  '/compliance-test': typeof ComplianceTestIndexRoute
  '/ai-detector': typeof AppProvenanceAiDetectorRoute
  '/copyright-detector': typeof AppProvenanceCopyrightDetectorRoute
  '/humanized-text-detector': typeof AppProvenanceHumanizedTextDetectorRoute
  '/writing-analysis': typeof AppProvenanceWritingAnalysisRoute
  '/document-redactor/options': typeof AppDocumentRedactorOptionsRoute
  '/document-redactor/result': typeof AppDocumentRedactorResultRoute
  '/payment-confirmation/$outcome': typeof AppPaymentConfirmationOutcomeRoute
  '/stealth-ai-writer/generate-article': typeof AppStealthAiWriterGenerateArticleRoute
  '/stealth-ai-writer/result': typeof AppStealthAiWriterResultRoute
  '/vexon/result': typeof AppVexonResultRoute
  '/document-redactor': typeof AppDocumentRedactorIndexRoute
  '/stealth-ai-writer': typeof AppStealthAiWriterIndexRoute
  '/vexon': typeof AppVexonIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/apply-promotion': typeof ApplyPromotionRoute
  '/auth': typeof AuthRouteWithChildren
  '/_app/_provenance': typeof AppProvenanceRouteWithChildren
  '/_app/account': typeof AppAccountRoute
  '/_app/all-products': typeof AppAllProductsRoute
  '/_app/api-agent-doc': typeof AppApiAgentDocRoute
  '/_app/api-agent-doc-new': typeof AppApiAgentDocNewRoute
  '/_app/contact-us': typeof AppContactUsRoute
  '/_app/content-enhancer': typeof AppContentEnhancerRoute
  '/_app/content-humanizer': typeof AppContentHumanizerRoute
  '/_app/document-redactor': typeof AppDocumentRedactorRouteWithChildren
  '/_app/history': typeof AppHistoryRoute
  '/_app/pricing': typeof AppPricingRoute
  '/_app/secure-llm': typeof AppSecureLlmRoute
  '/_app/seo-scanner': typeof AppSeoScannerRoute
  '/_app/stealth-ai-writer': typeof AppStealthAiWriterRouteWithChildren
  '/_app/vexon': typeof AppVexonRouteWithChildren
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/signin': typeof AuthSigninRoute
  '/auth/signup': typeof AuthSignupRoute
  '/auth/verify-account': typeof AuthVerifyAccountRoute
  '/compliance-test/quiz': typeof ComplianceTestQuizRoute
  '/_app/': typeof AppIndexRoute
  '/auth/': typeof AuthIndexRoute
  '/compliance-test/': typeof ComplianceTestIndexRoute
  '/_app/_provenance/ai-detector': typeof AppProvenanceAiDetectorRoute
  '/_app/_provenance/copyright-detector': typeof AppProvenanceCopyrightDetectorRoute
  '/_app/_provenance/humanized-text-detector': typeof AppProvenanceHumanizedTextDetectorRoute
  '/_app/_provenance/writing-analysis': typeof AppProvenanceWritingAnalysisRoute
  '/_app/document-redactor/options': typeof AppDocumentRedactorOptionsRoute
  '/_app/document-redactor/result': typeof AppDocumentRedactorResultRoute
  '/_app/payment-confirmation/$outcome': typeof AppPaymentConfirmationOutcomeRoute
  '/_app/stealth-ai-writer/generate-article': typeof AppStealthAiWriterGenerateArticleRoute
  '/_app/stealth-ai-writer/result': typeof AppStealthAiWriterResultRoute
  '/_app/vexon/result': typeof AppVexonResultRoute
  '/_app/document-redactor/': typeof AppDocumentRedactorIndexRoute
  '/_app/stealth-ai-writer/': typeof AppStealthAiWriterIndexRoute
  '/_app/vexon/': typeof AppVexonIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/apply-promotion'
    | '/auth'
    | '/account'
    | '/all-products'
    | '/api-agent-doc'
    | '/api-agent-doc-new'
    | '/contact-us'
    | '/content-enhancer'
    | '/content-humanizer'
    | '/document-redactor'
    | '/history'
    | '/pricing'
    | '/secure-llm'
    | '/seo-scanner'
    | '/stealth-ai-writer'
    | '/vexon'
    | '/auth/forgot-password'
    | '/auth/signin'
    | '/auth/signup'
    | '/auth/verify-account'
    | '/compliance-test/quiz'
    | '/'
    | '/auth/'
    | '/compliance-test'
    | '/ai-detector'
    | '/copyright-detector'
    | '/humanized-text-detector'
    | '/writing-analysis'
    | '/document-redactor/options'
    | '/document-redactor/result'
    | '/payment-confirmation/$outcome'
    | '/stealth-ai-writer/generate-article'
    | '/stealth-ai-writer/result'
    | '/vexon/result'
    | '/document-redactor/'
    | '/stealth-ai-writer/'
    | '/vexon/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/apply-promotion'
    | '/account'
    | '/all-products'
    | '/api-agent-doc'
    | '/api-agent-doc-new'
    | '/contact-us'
    | '/content-enhancer'
    | '/content-humanizer'
    | '/history'
    | '/pricing'
    | '/secure-llm'
    | '/seo-scanner'
    | '/auth/forgot-password'
    | '/auth/signin'
    | '/auth/signup'
    | '/auth/verify-account'
    | '/compliance-test/quiz'
    | '/'
    | '/auth'
    | '/compliance-test'
    | '/ai-detector'
    | '/copyright-detector'
    | '/humanized-text-detector'
    | '/writing-analysis'
    | '/document-redactor/options'
    | '/document-redactor/result'
    | '/payment-confirmation/$outcome'
    | '/stealth-ai-writer/generate-article'
    | '/stealth-ai-writer/result'
    | '/vexon/result'
    | '/document-redactor'
    | '/stealth-ai-writer'
    | '/vexon'
  id:
    | '__root__'
    | '/_app'
    | '/apply-promotion'
    | '/auth'
    | '/_app/_provenance'
    | '/_app/account'
    | '/_app/all-products'
    | '/_app/api-agent-doc'
    | '/_app/api-agent-doc-new'
    | '/_app/contact-us'
    | '/_app/content-enhancer'
    | '/_app/content-humanizer'
    | '/_app/document-redactor'
    | '/_app/history'
    | '/_app/pricing'
    | '/_app/secure-llm'
    | '/_app/seo-scanner'
    | '/_app/stealth-ai-writer'
    | '/_app/vexon'
    | '/auth/forgot-password'
    | '/auth/signin'
    | '/auth/signup'
    | '/auth/verify-account'
    | '/compliance-test/quiz'
    | '/_app/'
    | '/auth/'
    | '/compliance-test/'
    | '/_app/_provenance/ai-detector'
    | '/_app/_provenance/copyright-detector'
    | '/_app/_provenance/humanized-text-detector'
    | '/_app/_provenance/writing-analysis'
    | '/_app/document-redactor/options'
    | '/_app/document-redactor/result'
    | '/_app/payment-confirmation/$outcome'
    | '/_app/stealth-ai-writer/generate-article'
    | '/_app/stealth-ai-writer/result'
    | '/_app/vexon/result'
    | '/_app/document-redactor/'
    | '/_app/stealth-ai-writer/'
    | '/_app/vexon/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  ApplyPromotionRoute: typeof ApplyPromotionRoute
  AuthRoute: typeof AuthRouteWithChildren
  ComplianceTestQuizRoute: typeof ComplianceTestQuizRoute
  ComplianceTestIndexRoute: typeof ComplianceTestIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/apply-promotion': {
      id: '/apply-promotion'
      path: '/apply-promotion'
      fullPath: '/apply-promotion'
      preLoaderRoute: typeof ApplyPromotionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/compliance-test/': {
      id: '/compliance-test/'
      path: '/compliance-test'
      fullPath: '/compliance-test'
      preLoaderRoute: typeof ComplianceTestIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/': {
      id: '/auth/'
      path: '/'
      fullPath: '/auth/'
      preLoaderRoute: typeof AuthIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/compliance-test/quiz': {
      id: '/compliance-test/quiz'
      path: '/compliance-test/quiz'
      fullPath: '/compliance-test/quiz'
      preLoaderRoute: typeof ComplianceTestQuizRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/verify-account': {
      id: '/auth/verify-account'
      path: '/verify-account'
      fullPath: '/auth/verify-account'
      preLoaderRoute: typeof AuthVerifyAccountRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/signup': {
      id: '/auth/signup'
      path: '/signup'
      fullPath: '/auth/signup'
      preLoaderRoute: typeof AuthSignupRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/signin': {
      id: '/auth/signin'
      path: '/signin'
      fullPath: '/auth/signin'
      preLoaderRoute: typeof AuthSigninRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/forgot-password': {
      id: '/auth/forgot-password'
      path: '/forgot-password'
      fullPath: '/auth/forgot-password'
      preLoaderRoute: typeof AuthForgotPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_app/vexon': {
      id: '/_app/vexon'
      path: '/vexon'
      fullPath: '/vexon'
      preLoaderRoute: typeof AppVexonRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/stealth-ai-writer': {
      id: '/_app/stealth-ai-writer'
      path: '/stealth-ai-writer'
      fullPath: '/stealth-ai-writer'
      preLoaderRoute: typeof AppStealthAiWriterRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/seo-scanner': {
      id: '/_app/seo-scanner'
      path: '/seo-scanner'
      fullPath: '/seo-scanner'
      preLoaderRoute: typeof AppSeoScannerRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/secure-llm': {
      id: '/_app/secure-llm'
      path: '/secure-llm'
      fullPath: '/secure-llm'
      preLoaderRoute: typeof AppSecureLlmRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/pricing': {
      id: '/_app/pricing'
      path: '/pricing'
      fullPath: '/pricing'
      preLoaderRoute: typeof AppPricingRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/history': {
      id: '/_app/history'
      path: '/history'
      fullPath: '/history'
      preLoaderRoute: typeof AppHistoryRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/document-redactor': {
      id: '/_app/document-redactor'
      path: '/document-redactor'
      fullPath: '/document-redactor'
      preLoaderRoute: typeof AppDocumentRedactorRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/content-humanizer': {
      id: '/_app/content-humanizer'
      path: '/content-humanizer'
      fullPath: '/content-humanizer'
      preLoaderRoute: typeof AppContentHumanizerRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/content-enhancer': {
      id: '/_app/content-enhancer'
      path: '/content-enhancer'
      fullPath: '/content-enhancer'
      preLoaderRoute: typeof AppContentEnhancerRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/contact-us': {
      id: '/_app/contact-us'
      path: '/contact-us'
      fullPath: '/contact-us'
      preLoaderRoute: typeof AppContactUsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/api-agent-doc-new': {
      id: '/_app/api-agent-doc-new'
      path: '/api-agent-doc-new'
      fullPath: '/api-agent-doc-new'
      preLoaderRoute: typeof AppApiAgentDocNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/api-agent-doc': {
      id: '/_app/api-agent-doc'
      path: '/api-agent-doc'
      fullPath: '/api-agent-doc'
      preLoaderRoute: typeof AppApiAgentDocRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/all-products': {
      id: '/_app/all-products'
      path: '/all-products'
      fullPath: '/all-products'
      preLoaderRoute: typeof AppAllProductsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/account': {
      id: '/_app/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AppAccountRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/_provenance': {
      id: '/_app/_provenance'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AppProvenanceRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/vexon/': {
      id: '/_app/vexon/'
      path: '/'
      fullPath: '/vexon/'
      preLoaderRoute: typeof AppVexonIndexRouteImport
      parentRoute: typeof AppVexonRoute
    }
    '/_app/stealth-ai-writer/': {
      id: '/_app/stealth-ai-writer/'
      path: '/'
      fullPath: '/stealth-ai-writer/'
      preLoaderRoute: typeof AppStealthAiWriterIndexRouteImport
      parentRoute: typeof AppStealthAiWriterRoute
    }
    '/_app/document-redactor/': {
      id: '/_app/document-redactor/'
      path: '/'
      fullPath: '/document-redactor/'
      preLoaderRoute: typeof AppDocumentRedactorIndexRouteImport
      parentRoute: typeof AppDocumentRedactorRoute
    }
    '/_app/vexon/result': {
      id: '/_app/vexon/result'
      path: '/result'
      fullPath: '/vexon/result'
      preLoaderRoute: typeof AppVexonResultRouteImport
      parentRoute: typeof AppVexonRoute
    }
    '/_app/stealth-ai-writer/result': {
      id: '/_app/stealth-ai-writer/result'
      path: '/result'
      fullPath: '/stealth-ai-writer/result'
      preLoaderRoute: typeof AppStealthAiWriterResultRouteImport
      parentRoute: typeof AppStealthAiWriterRoute
    }
    '/_app/stealth-ai-writer/generate-article': {
      id: '/_app/stealth-ai-writer/generate-article'
      path: '/generate-article'
      fullPath: '/stealth-ai-writer/generate-article'
      preLoaderRoute: typeof AppStealthAiWriterGenerateArticleRouteImport
      parentRoute: typeof AppStealthAiWriterRoute
    }
    '/_app/payment-confirmation/$outcome': {
      id: '/_app/payment-confirmation/$outcome'
      path: '/payment-confirmation/$outcome'
      fullPath: '/payment-confirmation/$outcome'
      preLoaderRoute: typeof AppPaymentConfirmationOutcomeRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/document-redactor/result': {
      id: '/_app/document-redactor/result'
      path: '/result'
      fullPath: '/document-redactor/result'
      preLoaderRoute: typeof AppDocumentRedactorResultRouteImport
      parentRoute: typeof AppDocumentRedactorRoute
    }
    '/_app/document-redactor/options': {
      id: '/_app/document-redactor/options'
      path: '/options'
      fullPath: '/document-redactor/options'
      preLoaderRoute: typeof AppDocumentRedactorOptionsRouteImport
      parentRoute: typeof AppDocumentRedactorRoute
    }
    '/_app/_provenance/writing-analysis': {
      id: '/_app/_provenance/writing-analysis'
      path: '/writing-analysis'
      fullPath: '/writing-analysis'
      preLoaderRoute: typeof AppProvenanceWritingAnalysisRouteImport
      parentRoute: typeof AppProvenanceRoute
    }
    '/_app/_provenance/humanized-text-detector': {
      id: '/_app/_provenance/humanized-text-detector'
      path: '/humanized-text-detector'
      fullPath: '/humanized-text-detector'
      preLoaderRoute: typeof AppProvenanceHumanizedTextDetectorRouteImport
      parentRoute: typeof AppProvenanceRoute
    }
    '/_app/_provenance/copyright-detector': {
      id: '/_app/_provenance/copyright-detector'
      path: '/copyright-detector'
      fullPath: '/copyright-detector'
      preLoaderRoute: typeof AppProvenanceCopyrightDetectorRouteImport
      parentRoute: typeof AppProvenanceRoute
    }
    '/_app/_provenance/ai-detector': {
      id: '/_app/_provenance/ai-detector'
      path: '/ai-detector'
      fullPath: '/ai-detector'
      preLoaderRoute: typeof AppProvenanceAiDetectorRouteImport
      parentRoute: typeof AppProvenanceRoute
    }
  }
}

interface AppProvenanceRouteChildren {
  AppProvenanceAiDetectorRoute: typeof AppProvenanceAiDetectorRoute
  AppProvenanceCopyrightDetectorRoute: typeof AppProvenanceCopyrightDetectorRoute
  AppProvenanceHumanizedTextDetectorRoute: typeof AppProvenanceHumanizedTextDetectorRoute
  AppProvenanceWritingAnalysisRoute: typeof AppProvenanceWritingAnalysisRoute
}

const AppProvenanceRouteChildren: AppProvenanceRouteChildren = {
  AppProvenanceAiDetectorRoute: AppProvenanceAiDetectorRoute,
  AppProvenanceCopyrightDetectorRoute: AppProvenanceCopyrightDetectorRoute,
  AppProvenanceHumanizedTextDetectorRoute:
    AppProvenanceHumanizedTextDetectorRoute,
  AppProvenanceWritingAnalysisRoute: AppProvenanceWritingAnalysisRoute,
}

const AppProvenanceRouteWithChildren = AppProvenanceRoute._addFileChildren(
  AppProvenanceRouteChildren,
)

interface AppDocumentRedactorRouteChildren {
  AppDocumentRedactorOptionsRoute: typeof AppDocumentRedactorOptionsRoute
  AppDocumentRedactorResultRoute: typeof AppDocumentRedactorResultRoute
  AppDocumentRedactorIndexRoute: typeof AppDocumentRedactorIndexRoute
}

const AppDocumentRedactorRouteChildren: AppDocumentRedactorRouteChildren = {
  AppDocumentRedactorOptionsRoute: AppDocumentRedactorOptionsRoute,
  AppDocumentRedactorResultRoute: AppDocumentRedactorResultRoute,
  AppDocumentRedactorIndexRoute: AppDocumentRedactorIndexRoute,
}

const AppDocumentRedactorRouteWithChildren =
  AppDocumentRedactorRoute._addFileChildren(AppDocumentRedactorRouteChildren)

interface AppStealthAiWriterRouteChildren {
  AppStealthAiWriterGenerateArticleRoute: typeof AppStealthAiWriterGenerateArticleRoute
  AppStealthAiWriterResultRoute: typeof AppStealthAiWriterResultRoute
  AppStealthAiWriterIndexRoute: typeof AppStealthAiWriterIndexRoute
}

const AppStealthAiWriterRouteChildren: AppStealthAiWriterRouteChildren = {
  AppStealthAiWriterGenerateArticleRoute:
    AppStealthAiWriterGenerateArticleRoute,
  AppStealthAiWriterResultRoute: AppStealthAiWriterResultRoute,
  AppStealthAiWriterIndexRoute: AppStealthAiWriterIndexRoute,
}

const AppStealthAiWriterRouteWithChildren =
  AppStealthAiWriterRoute._addFileChildren(AppStealthAiWriterRouteChildren)

interface AppVexonRouteChildren {
  AppVexonResultRoute: typeof AppVexonResultRoute
  AppVexonIndexRoute: typeof AppVexonIndexRoute
}

const AppVexonRouteChildren: AppVexonRouteChildren = {
  AppVexonResultRoute: AppVexonResultRoute,
  AppVexonIndexRoute: AppVexonIndexRoute,
}

const AppVexonRouteWithChildren = AppVexonRoute._addFileChildren(
  AppVexonRouteChildren,
)

interface AppRouteChildren {
  AppProvenanceRoute: typeof AppProvenanceRouteWithChildren
  AppAccountRoute: typeof AppAccountRoute
  AppAllProductsRoute: typeof AppAllProductsRoute
  AppApiAgentDocRoute: typeof AppApiAgentDocRoute
  AppApiAgentDocNewRoute: typeof AppApiAgentDocNewRoute
  AppContactUsRoute: typeof AppContactUsRoute
  AppContentEnhancerRoute: typeof AppContentEnhancerRoute
  AppContentHumanizerRoute: typeof AppContentHumanizerRoute
  AppDocumentRedactorRoute: typeof AppDocumentRedactorRouteWithChildren
  AppHistoryRoute: typeof AppHistoryRoute
  AppPricingRoute: typeof AppPricingRoute
  AppSecureLlmRoute: typeof AppSecureLlmRoute
  AppSeoScannerRoute: typeof AppSeoScannerRoute
  AppStealthAiWriterRoute: typeof AppStealthAiWriterRouteWithChildren
  AppVexonRoute: typeof AppVexonRouteWithChildren
  AppIndexRoute: typeof AppIndexRoute
  AppPaymentConfirmationOutcomeRoute: typeof AppPaymentConfirmationOutcomeRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppProvenanceRoute: AppProvenanceRouteWithChildren,
  AppAccountRoute: AppAccountRoute,
  AppAllProductsRoute: AppAllProductsRoute,
  AppApiAgentDocRoute: AppApiAgentDocRoute,
  AppApiAgentDocNewRoute: AppApiAgentDocNewRoute,
  AppContactUsRoute: AppContactUsRoute,
  AppContentEnhancerRoute: AppContentEnhancerRoute,
  AppContentHumanizerRoute: AppContentHumanizerRoute,
  AppDocumentRedactorRoute: AppDocumentRedactorRouteWithChildren,
  AppHistoryRoute: AppHistoryRoute,
  AppPricingRoute: AppPricingRoute,
  AppSecureLlmRoute: AppSecureLlmRoute,
  AppSeoScannerRoute: AppSeoScannerRoute,
  AppStealthAiWriterRoute: AppStealthAiWriterRouteWithChildren,
  AppVexonRoute: AppVexonRouteWithChildren,
  AppIndexRoute: AppIndexRoute,
  AppPaymentConfirmationOutcomeRoute: AppPaymentConfirmationOutcomeRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface AuthRouteChildren {
  AuthForgotPasswordRoute: typeof AuthForgotPasswordRoute
  AuthSigninRoute: typeof AuthSigninRoute
  AuthSignupRoute: typeof AuthSignupRoute
  AuthVerifyAccountRoute: typeof AuthVerifyAccountRoute
  AuthIndexRoute: typeof AuthIndexRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthForgotPasswordRoute: AuthForgotPasswordRoute,
  AuthSigninRoute: AuthSigninRoute,
  AuthSignupRoute: AuthSignupRoute,
  AuthVerifyAccountRoute: AuthVerifyAccountRoute,
  AuthIndexRoute: AuthIndexRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  ApplyPromotionRoute: ApplyPromotionRoute,
  AuthRoute: AuthRouteWithChildren,
  ComplianceTestQuizRoute: ComplianceTestQuizRoute,
  ComplianceTestIndexRoute: ComplianceTestIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
